import { DefaultYourFinanceData, DefaultYourFinanceSubmit, YourFinanceState } from './yourFinanceTypes';

// eslint-disable-next-line import/prefer-default-export
export const initialStateYourFinance: YourFinanceState = {
    data: DefaultYourFinanceData,
    submitData: DefaultYourFinanceSubmit,
    submitUrl: 'api/BorrowingEstimation/BorrowingAmount',
    isSubmitDataReady: false,
};
